// Brand logo SVGs (Facebook, Instagram, WhatsApp). Use exact brand marks/colors when needed.

export const FacebookIcon = ({ className = "", size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    <path
      fill="#1877F2"
      d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.412c0-3.017 1.792-4.683 4.533-4.683 1.312 0 2.686.235 2.686.235v2.97h-1.514c-1.49 0-1.955.93-1.955 1.886v2.262h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073Z"
    />
    <path
      fill="#fff"
      d="m16.671 15.563.532-3.49h-3.328V9.812c0-.955.466-1.886 1.955-1.886h1.514V4.957s-1.374-.235-2.686-.235c-2.741 0-4.533 1.666-4.533 4.683v2.66H7.078v3.49h3.047V24c.62.097 1.252.146 1.875.146.624 0 1.255-.05 1.875-.146v-8.437h2.796Z"
    />
  </svg>
);

export const InstagramIcon = ({ className = "", size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    <defs>
      <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%">
        <stop offset="0%" stopColor="#FDF497" />
        <stop offset="5%" stopColor="#FDF497" />
        <stop offset="45%" stopColor="#FD5949" />
        <stop offset="60%" stopColor="#D6249F" />
        <stop offset="90%" stopColor="#285AEB" />
      </radialGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#ig-grad)" />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="1.8"
      d="M16.5 7.5h.01M12 8.4a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2Zm-4.5-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3Z"
    />
  </svg>
);

export const WhatsAppIcon = ({ className = "", size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    <path
      fill="#25D366"
      d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.337 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24Z"
    />
    <path
      fill="#fff"
      d="M8.998 6.43c-.214-.476-.44-.485-.643-.493l-.547-.007a1.05 1.05 0 0 0-.762.357c-.262.286-1 .976-1 2.378 0 1.402 1.024 2.758 1.166 2.948.143.19 1.977 3.171 4.886 4.323 2.418.957 2.91.767 3.435.72.524-.048 1.692-.692 1.93-1.36.238-.667.238-1.24.167-1.36-.072-.119-.262-.19-.547-.333-.286-.143-1.692-.835-1.954-.93-.262-.095-.453-.143-.643.143-.19.286-.738.93-.905 1.121-.167.19-.333.214-.62.072-.286-.143-1.207-.445-2.299-1.418-.85-.758-1.424-1.694-1.591-1.98-.167-.286-.018-.441.125-.583.129-.128.286-.333.428-.5.143-.167.19-.286.286-.476.095-.19.048-.357-.024-.5-.071-.143-.628-1.554-.882-2.117Z"
    />
  </svg>
);
